// Job 软删除前置判定的纯逻辑（从 JobList/index.tsx 抽出，便于 node:test 单测）。

// 可软删除的终态 Job 状态（与后端 job_service.JOB_TERMINAL_STATUS_IDS 对齐）：
// cancelled(1) / succeeded(15) / not_pass(20) / failed(25) / unknown(30) / compile_failed(35)。
// 运行中 / 排队中的 Job 须先「取消」才能删除。
export const TERMINAL_JOB_STATUSES = new Set([1, 15, 20, 25, 30, 35]);

/**
 * 软删除前置校验：非创建者 / 非终态返回置灰原因（tooltip 文案）；可删返回 null。
 * 创建者判定先于状态判定——非创建者连终态也不给删。
 *
 * 口径是后端 job_service.soft_delete_job 的 email 子集：只比对 job.creator 与
 * 当前用户 email。后端在用户无 email 时会回退按 name 比对，前端不回退——
 * 用户无 email（或 me 尚未加载完）时保守置灰，删不误给入口；后端校验始终权威。
 */
export function deleteDisabledReason(
  job: { creator?: string | null; status: number },
  currentUserEmail: string,
): string | null {
  if (job.creator !== currentUserEmail) return '仅创建者可删除';
  if (!TERMINAL_JOB_STATUSES.has(job.status)) return '任务未结束，请先取消';
  return null;
}
